<template>
  <div class="signup">
    <h2>{{ $t('auth.createNewAccount') }}</h2>
    <form name="signup">
      <div class="form-group">
        <div class="input-group">
          <input
            data-vv-name="fullName"
            v-validate="{ required:true }"
            data-vv-validate-on="blur"
            type="text"
            id="fullName"
            required="required"
            v-model="fullName"
          />
          <label class="control-label" for="fullName">{{ $t('auth.fullName') }}</label>
          <i class="bar"></i>
          <small
            v-if="errors.has('fullName')"
            class="help text-danger"
          >{{ errors.first('fullName').replace("fullName",$t('auth.fullName').toLowerCase()) }}</small>
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <input
            data-vv-name="emailAddress"
            v-validate="{required:true, regex: emailRegex }"
            data-vv-validate-on="blur"
            type="text"
            id="emailAddress"
            required="required"
            v-model="emailAddress"
          />
          <label class="control-label" for="emailAddress">{{ $t('auth.email') }}</label>
          <i class="bar"></i>
          <small v-if="errors.has('emailAddress')" class="help text-danger">{{ errors.first('emailAddress') }}</small>
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <input
            data-vv-name="password"
            v-validate="{ required:true }"
            data-vv-validate-on="blur"
            type="password"
            id="password"
            required="required"
            v-model="password"
          />
          <label class="control-label" for="password">{{ $t('auth.password') }}</label>
          <i class="bar"></i>
          <small
            v-if="errors.has('password')"
            class="help text-danger"
          >{{ errors.first('password').replace("password",$t('auth.password').toLowerCase()) }}</small>
        </div>
      </div>
      <div class="d-flex align--center justify--space-between down-container">
        <button
          :disabled="errors.items.length > 0"
          class="btn btn-primary"
          @click.prevent="register()"
        >{{ $t('auth.signUp') }}</button>
        <router-link
          class="link pl-2 text-center"
          :to="{name: 'login'}"
        >{{ $t('auth.alreadyJoined') }}</router-link>
      </div>
    </form>
  </div>
</template>

<script>
import { auth } from "../../../services/api/auth";

export default {
  name: "signup",
  data() {
    return {
      fullName: "",
      emailAddress: "",
      password: "",
      agreedToTerms: false,
      get emailRegex() {
        return mailRegex;
      }
    };
  },
  methods: {
    register() {
      this.$validator.validateAll().then(() => {
        if (this.errors.items.length > 0) return;
        let emailAddress = this.emailAddress;
        let fullName = this.fullName;
        let password = this.password;
        auth
          .signup({fullName,emailAddress,password})
          .then(success => {
            if (!success) {
              this.showSignUpError();
              return;
            }
            
            this.$store
              .dispatch("login", { email:emailAddress, password })
              .then(usr => {
                this.$router.push("/admin/home");
              })
              .catch(err => console.log(err));
          })
          .catch(() => {
            this.showSignUpError();
          });
      });
    }
  },
  showSignUpError() {
    this.showToast("Something went wrong");
  }
};

let mailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
</script>

<style lang="scss">
.signup {
  @include media-breakpoint-down(md) {
    width: 100%;
    padding-right: 2rem;
    padding-left: 2rem;
  }

  h2 {
    text-align: center;
  }
  width: 21.375rem;

  .down-container {
    margin-top: 2.6875rem;
  }
}
</style>
